

function BoxInput({ text, inputValue, chooseValue }) {
    return (
        <div className="flex flex-row-reverse items-center justify-between mb-4">
            <p>{text}</p>
            <input
                value={inputValue}
                onChange={(e) => chooseValue(e.target.value)}
                className="w-9/12 p-1 border border-slate-200 rounded"
            />
        </div>
    )
}
export default BoxInput;